var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"btn-test",attrs:{"icon":"el-icon-lightning","size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.label || _vm.$t('settings.adConnections.testConnection'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }